// dashboardStore.js
import { create } from 'zustand';
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

export const useDashboard = create((set) => ({
  data: null,
  load: async () => {
    const res = await fetch(
  `${apiBaseUrl}/api/dashboard?widgets=` +
  "changes," +
  "customers," +
  "suppliers," +
  "users," +
  "attendance," +
  "featureRequests," +
  "documents," +
  "mistakes," +
  "purchaseOrders," +
  "quotations," +
  "costs," +
  "invoices," +
  "tasks," +
  "inventory," +
  "reasons"
);

    const json = await res.json();
    console.log(json);
    set({ data: json });
  }
}));
